angular.module('skeyenoteWebApp').controller('ElasticInputCtrl', ElasticInputCtrl);

function ElasticInputCtrl() {
  let vm = this;
  vm.showEditor = false;
  vm.value = '';
}
